export const FILES_UPLOAD_REQUEST = "FILES_UPLOAD_REQUEST";
export const FILES_UPLOAD_PROGRESS = "FILES_UPLOAD_PROGRESS";
export const FILES_UPLOAD_SUCCESS = "FILES_UPLOAD_SUCCESS";
export const FILES_UPLOAD_FAILURE = "FILES_UPLOAD_FAILURE";
export const FILES_UPLOAD_CLEAN_STORE = "FILES_UPLOAD_CLEAN_STORE";
